const steps = [
  { num: "01", title: "Start Online", desc: "Choose your processing speed and complete our secure online application. Takes 5 minutes." },
  { num: "02", title: "Document Prep", desc: "We review your documents and coordinate your acceptance facility visit in Bentonville or Rogers." },
  { num: "03", title: "Courier Handoff", desc: "Our registered State Department courier picks up your sealed envelope and delivers it directly." },
  { num: "04", title: "Passport Delivered", desc: "Your passport arrives at your Bentonville address via secure overnight shipping." },
];

export default function BentonvilleHowItWorksSection() {
  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-[#F7F8FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">How It Works</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">5 Steps to Your Passport</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
          {[...steps, { num: "05", title: "Travel Ready", desc: "Your new passport in hand — ready for Walmart supplier visits, Crystal Bridges acquisitions, or family vacation." }].map((s, i) => (
            <div key={i} className="text-center">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#1A365D] text-white font-bold text-lg mx-auto mb-4">{s.num}</div>
              <h3 className="font-bold text-[#1A365D] text-base mb-2">{s.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}